module.exports = __webpack_public_path__ + "assets/img/图层 640@2x.34fe5f13.png";